import CheckoutContext from "@context/checkout/context";
import { useContext } from "react";
var useCheckout = function useCheckout() {
  return useContext(CheckoutContext);
};
export default useCheckout;